import { Component, OnDestroy } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProgressData } from '../../dtos/progress-data';
import { ProgressIndicatingComponentParams } from '../../services/progress-indicating.service';

@Component({
    selector: 'app-progress-indicator',
    templateUrl: './progress-indicator.component.html',
    styleUrls: ['./progress-indicator.component.scss']
})
export class ProgressIndicatorComponent implements OnDestroy {
    private progress: Observable<ProgressData>;

    public details?: string = '';
    public header: string = '';

    private unsubscribe$ = new Subject<void>();

    public constructor(
        public ref: DynamicDialogRef,
        config: DynamicDialogConfig) {
        const data = config.data as ProgressIndicatingComponentParams;
        this.details = data.initial.details;
        this.header = data.initial.header;
        this.progress = data.progress$ as Observable<ProgressData>;
        this.progress
            .pipe(
                takeUntil(this.unsubscribe$)
            )
            .subscribe(data => {
                this.details = data.details;
                this.header = data.header;
                if (data.done) {
                    this.ref.close();
                }
            });
    }

    public ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
